declare global {
  interface Window {
    bootstrap: {
      Modal: new (el: Element) => any;
    };
  }
}
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../contexts/LanguageContext";
import PageLayout from "../../../components/modern/PageLayout/PageLayout";
import { HiDocumentText, HiClipboardList, HiDocumentDuplicate, HiClock, HiChartBar } from "react-icons/hi";
import { OrderForm, OrderStatus, OrderHistory, OrderInvoices, OrderSummary } from "./components";
import { adminApi } from "../../../utils/api";
import { showSuccessToast, showErrorToast } from "../../../utils/toastNotifications";
import "./EditOrder.scss";

export const EditOrder = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation('orders');
  const { direction, isRTL } = useLanguage();
  const navigate = useNavigate();

  const [formData, setFormData] = useState<any>({
    link: "",
    merchantName: "",
    description: "",
    quantity: 1,
    width: 0,
    height: 0,
    length: 0,
    weight: 0,
    extendedDescription: "",
    destinationCountryId: 0,
    originCountryId: 0,
    paymentMethod: 0,
    categoryId: 0,
    shippingCompanyId: 0,
    merchentDeliveryFee: 0,
    merchentDeliveryFeeInBaseCurrency: 0,
    orderStatus: 0,
    itemType: "",
    deliveryMode: "",
    itemPrice: 0,
    paymentMethodId: 0,
    paymentType: 0,
    servicePrice: 0,
    totalPrice: 0,
    additionaCost: 0,
    shippingCompanyPricePerLB: 0,
    ShippingCompanyId: 0,
    currencyId: 0,
    orderPrice: 0,
    exchangePrice: 0,
    diementionalWeight: 0,
    shippingCost: 0,
    shippingInssurance: 0,
    shippingFuelCost: 0,
    tax: 0,
    buyForMeCost: 0,
    paymentMethodCost: 0,
    refundType: 0,
    invoices: [],
    orderLogs: [],
    voucherValue: 0,
    hasShippingInssurance: false,
    dgFees: 0,
    enableDGFees: false,
    cityId: 0,
    localDeliveryFee: 0,
    weightMeasurementUnitId: null,
    lengthMeasurementUnitId: null
  });
  const [orderStatusForm, setOrderStatusForm] = useState<any>({
    orderStatus: 0,
    refundType: 0,
    comment: "",
    orderId: id,
    extraField: "",
    paymentGatewayId: null,
  });
  const [isLBPriceEnabled, setIsLBPriceEnabled] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(0);
  // Financial Control: immutable net price + FX-lock metadata read from the invoice snapshot.
  const [netPriceUsd, setNetPriceUsd] = useState<number | null>(null);
  const [netPriceInIqd, setNetPriceInIqd] = useState<number | null>(null);
  const [fxLock, setFxLock] = useState<any>(null);
  const [paymentGateways, setPaymentGateways] = useState<any[]>([]);

  const [token] = useState(localStorage.getItem("token"));
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shippingCompanys, setShippingCompanies] = useState([]);
  const [cities, setCities] = useState([]);
  const [weightMeasurementUnits, setWeightMeasurementUnits] = useState([]);
  const [lengthMeasurementUnits, setLengthMeasurementUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [calculatingOrder, setCalculatingOrder] = useState(false);
  const [resettingOrder, setResettingOrder] = useState(false);
  const [reload, setReload] = useState(false);
  const [messageStatus, setMessageStatus] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("Are you sure you want to reset this order?");
  const [selectedLog, setSelectedLog] = useState(null);

  const getExtraFieldLabel = () => {
    if (orderStatusForm.refundType == 2) return null;
    console.log("orderStatusForm.orderStatus");
    console.log(orderStatusForm.orderStatus);
    console.log("formData?.paymentType");
    console.log(formData?.paymentType);
    const status = parseInt(orderStatusForm.orderStatus);
    const paymentType = formData?.paymentType;

    if (status === 10 && (paymentType === 2 || paymentType === 1)) return t('fields.courierReceiptNo'); // PurchaseUnderProcess
    if (status === 13) return t('fields.orderNumber'); // OrderPurchased
    if (status === 20) return t('fields.shippingOrderNumber'); // Shipped
    if (status === 25 && (paymentType === 0 || paymentType === 1)) return t('fields.courierReceiptNo'); // Delivered
    if (status === 19) return t('fields.reorderNumber'); // Reordered
    if (status === 18) return t('fields.refundReceiptNo'); // Reordered

    return null;
  };

  // Fetch order details
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await adminApi.call(`/adminorder/${id}`, 'GET');

        if (!response.success) {
          showErrorToast(response.error || "Failed to fetch order");
          return;
        }

        const data = response.data;
        setFormData(data.order);
        setExchangeRate(Number(data.exchangeRate));
        setNetPriceUsd(data.netPriceUsd ?? null);
        setNetPriceInIqd(data.netPriceInIqd ?? null);
        setFxLock(data.fxLock ?? null);
        // $("#table-logs-order").DataTable();
      } catch (error) {
        showErrorToast("Error: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [id, reload, i18n.language]);

  // Fetch country list
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await adminApi.call('/country', 'GET');

        if (!response.success) {
          showErrorToast(response.error || "Failed to fetch countries");
          return;
        }

        setCountries(response.data?.items?.filter((x: any) => !x.isSuspended) || []);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchCountries();
  }, [i18n.language]);

  // Fetch payment gateways list
  useEffect(() => {
    const fetchPaymentGateways = async () => {
      try {
        const response = await adminApi.call('/paymentgateway/active', 'GET');

        if (!response.success) {
          setPaymentGateways([]);
          return;
        }

        setPaymentGateways(response.data || []);
      } catch (error) {
        console.error("Error fetching payment gateways:", error);
        setPaymentGateways([]);
      }
    };

    fetchPaymentGateways();
  }, [i18n.language]);

  // Fetch currencies list
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await adminApi.call('/currency/GetBothAndSourceCurrencies?pageSize=1000000', 'GET');

        if (!response.success) {
          showErrorToast(response.error || "Failed to fetch currencies");
          return;
        }

        setCurrencies(response.data?.items);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchCurrencies();
  }, []);

  // Fetch cities list
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await adminApi.call('/city?page=1&pageSize=1000', 'GET');

        if (!response.success) {
          setCities([]);
          return;
        }

        setCities(response.data?.items || []);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchCities();
  }, []);

  // Fetch Categories list
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_APP_API_BASE_URL}/category?pageSize=10000`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch categories");

        const data = await response.json();
        setCategories(data.items);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchCategories();
  }, []);

  // Fetch Payment Methods list
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_APP_API_BASE_URL
          }/paymentmethod?pageSize=10000`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch payment methods");

        const data = await response.json();
        setPaymentMethods(data.items);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    fetchPaymentMethods();
  }, []);
  // Fetch Shipping Companies list with filters - only when order data is loaded with valid countries
  useEffect(() => {
    const fetchShippingCompanies = async () => {
      try {
        // Build query parameters with filters
        const params = new URLSearchParams();
        params.append('pageSize', '10000');
        params.append('isActive', 'true');

        if (formData.originCountryId && formData.originCountryId > 0) {
          params.append('sourceCountryId', formData.originCountryId.toString());
        }

        if (formData.destinationCountryId && formData.destinationCountryId > 0) {
          params.append('destinationCountryId', formData.destinationCountryId.toString());
        }

        const response = await fetch(
          `${import.meta.env.VITE_APP_API_BASE_URL}/shippingCompany?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch shipping companies");

        const data = await response.json();
        setShippingCompanies(data.items || []);
      } catch (error) {
        showErrorToast("Error: " + error.message);
      }
    };

    // Only fetch if both countries are set and valid
    if (formData.originCountryId && formData.originCountryId > 0 &&
      formData.destinationCountryId && formData.destinationCountryId > 0) {
      fetchShippingCompanies();
    }
  }, [formData.originCountryId, formData.destinationCountryId, token]);

  // Fetch measurement units
  useEffect(() => {
    const fetchMeasurementUnits = async () => {
      try {
        // Fetch weight measurement units (type 1)
        const weightResponse = await fetch(
          `${import.meta.env.VITE_APP_API_BASE_URL}/measurementunit/by-type/1`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (weightResponse.ok) {
          const weightData = await weightResponse.json();
          setWeightMeasurementUnits(weightData);
        }

        // Fetch length measurement units (type 0)
        const lengthResponse = await fetch(
          `${import.meta.env.VITE_APP_API_BASE_URL}/measurementunit/by-type/0`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (lengthResponse.ok) {
          const lengthData = await lengthResponse.json();
          setLengthMeasurementUnits(lengthData);
        }
      } catch (error) {
        console.error("Error fetching measurement units:", error);
      }
    };

    fetchMeasurementUnits();
  }, []);

  // Handle input change
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    console.log(name);
    console.log(value);

    // Handle checkbox inputs differently
    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]:
        name.includes("CountryId") ||
          name.includes("CategoryId") ||
          name.includes("Type") ||
          name.includes("deliveryMode") ||
          name.includes("MeasurementUnitId") ||
          name === "initialPartialPayment" ||
          name === "quantity" ||
          name === "itemPrice" ||
          name === "merchentDeliveryFee" ||
          name === "merchentDeliveryFeeInBaseCurrency" ||
          name === "width" ||
          name === "height" ||
          name === "length" ||
          name === "weight" ||
          name === "shippingCompanyPricePerLB"
          ? (Number(value) as number)
          : value,
    }));
    console.table(formData);
  };

  // Handle form status input change
  const handleStatusFormInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name);
    console.log(value);
    setOrderStatusForm((prevData) => ({
      ...prevData,
      [name]:
        name.includes("orderStatus") || name.includes("refundType")
          ? (Number(value) as number)
          : value,
    }));
  };

  // Handle quantity change
  const handleQuantityChange = (increment) => {
    setFormData((prevData) => ({
      ...prevData,
      quantity: Math.max(1, prevData.quantity + increment),
    }));
    console.table(formData);
  };

  // Submit updated order
  const updateOrder = async () => {
    setUpdating(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_APP_API_BASE_URL}/adminorder/validate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        showErrorToast(errorData.message || "Something went wrong");
        return;
      }
      setUpdating(false);
      setReload(!reload);
      showSuccessToast("Order updated successfully!");
      navigate("/order/edit/" + id);
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setUpdating(false);
    }
  };

  const confirmPendingStatus = () => {
    const status = Number(orderStatusForm.orderStatus);
    const paymentType = formData?.paymentType;
    const hasExtraField = !!getExtraFieldLabel();
    const isInvoiceRelatedExtraField =
      ((status === 10 || status === 31) && (paymentType === 2 || paymentType === 1)) ||
      (status === 25 && (paymentType === 0 || paymentType === 1));

    const sortedInvoicesByCreatedAtAsc = Array.isArray(formData?.invoices)
      ? [...formData.invoices].sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
      : [];

    let invoiceForCurrentStatus: any = null;
    if (sortedInvoicesByCreatedAtAsc.length > 0) {
      if (paymentType === 1) {
        if (status === 10 || status === 31) {
          invoiceForCurrentStatus = sortedInvoicesByCreatedAtAsc[0] ?? null;
        } else if (status === 25) {
          invoiceForCurrentStatus = sortedInvoicesByCreatedAtAsc[1] ?? sortedInvoicesByCreatedAtAsc[0] ?? null;
        } else {
          invoiceForCurrentStatus = sortedInvoicesByCreatedAtAsc[sortedInvoicesByCreatedAtAsc.length - 1] ?? null;
        }
      } else {
        invoiceForCurrentStatus = sortedInvoicesByCreatedAtAsc[sortedInvoicesByCreatedAtAsc.length - 1] ?? null;
      }
    }

    const shouldRequireExtraField = hasExtraField && (!isInvoiceRelatedExtraField || !invoiceForCurrentStatus?.isCollected);

    // Handle reset order modal
    if (orderStatusForm.orderStatus == 0) {
      const modalEl = document.getElementById("confirmPendingModal");
      const mes = "Are you sure you want to reset this order?";
      setConfirmMessage(mes);
      if (modalEl && window.bootstrap && window.bootstrap.Modal) {
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      } else {
        console.warn("Bootstrap modal is not available yet.");
      }
      return;
    }

    // For voucher refunds, we don't show modal - the inline form will handle approval
    if (orderStatusForm.orderStatus == 18 && orderStatusForm.refundType == 2) {
      if (shouldRequireExtraField && !orderStatusForm.extraField?.trim()) {
        setMessageStatus(`${getExtraFieldLabel()} is required`);
        return;
      }
      updateOrderStatus();
      return;
    }

    // Check if extraField is required and missing
    if (shouldRequireExtraField && !orderStatusForm.extraField?.trim()) {
      setMessageStatus(`${getExtraFieldLabel()} ${t('validation.required')}`);
      return;
    }
    updateOrderStatus();
  };

  // Submit updated order
  const updateOrderStatus = async () => {
    const modalEl = document.getElementById("confirmPendingModal");
    const modal = new window.bootstrap.Modal(modalEl);
    modal.hide();
    setUpdatingStatus(true);
    setUpdating(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_APP_API_BASE_URL}/adminorder/updatestatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(orderStatusForm),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        showErrorToast(errorData.message || "Something went wrong");
        return;
      }
      setReload(!reload);
      showSuccessToast("Order updated successfully!");
      // Clear comment and extraField after successful save
      setOrderStatusForm((prevData) => ({
        ...prevData,
        comment: "",
        extraField: "",
      }));
      navigate("/order/edit/" + id);
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setUpdatingStatus(false);
      setUpdating(false);
    }
  };

  const resetOrder = async () => {
    setResettingOrder(true);
    const resetStatusForm = {
      ...orderStatusForm,
      orderStatus: 0
    };
    try {
      const response = await fetch(`${import.meta.env.VITE_APP_API_BASE_URL}/adminorder/updatestatus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(resetStatusForm)
      });

      if (response.ok) {
        showSuccessToast(t('messages.orderReset'));
        setReload(!reload); // Trigger refetch by toggling reload state
      } else {
        showErrorToast(t('messages.resetFailed'));
      }
    } catch (error) {
      console.error('Error resetting order:', error);
      showErrorToast(t('messages.resetFailed'));
    } finally {
      setResettingOrder(false);
    }
  };

  // Submit updated order
  const calculateOrder = async () => {
    setCalculatingOrder(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_APP_API_BASE_URL}/adminorder/calculate/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      var data = await response.json();
      console.log(data);
      if (!response.ok) {
        if (data.message) {
          showErrorToast(data.message);
          return;
        }
        throw new Error("Failed to update order");
      }
      setReload(!reload);

      showSuccessToast("Order updated successfully!");
      navigate("/order/edit/" + formData.id);
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setCalculatingOrder(false);
    }
  };

  const getStatusBadge = (status: number) => {
    const statusMap: { [key: number]: { text: string; color: string } } = {
      0: { text: t('statusOptions.0'), color: "secondary" },
      1: { text: t('statusOptions.1'), color: "info" },
      2: { text: t('statusOptions.2'), color: "danger" },
      3: { text: t('statusOptions.3'), color: "primary" },
      4: { text: t('statusOptions.4'), color: "danger" },
      5: { text: t('statusOptions.5'), color: "secondary" },
      6: { text: t('statusOptions.6'), color: "success" },
      7: { text: t('statusOptions.7'), color: "success" },
      8: { text: t('statusOptions.8'), color: "danger" },
      9: { text: t('statusOptions.9'), color: "warning" },
      10: { text: t('statusOptions.10'), color: "warning" },
      11: { text: t('statusOptions.11'), color: "dark" },
      12: { text: t('statusOptions.12'), color: "danger" },
      13: { text: t('statusOptions.13'), color: "info" },
      14: { text: t('statusOptions.14'), color: "primary" },
      15: { text: t('statusOptions.15'), color: "success" },
      16: { text: t('statusOptions.16'), color: "danger" },
      17: { text: t('statusOptions.17'), color: "warning" },
      18: { text: t('statusOptions.18'), color: "info" },
      19: { text: t('statusOptions.19'), color: "secondary" },
      20: { text: t('statusOptions.20'), color: "primary" },
      21: { text: t('statusOptions.21'), color: "success" },
      22: { text: t('statusOptions.22'), color: "warning" },
      23: { text: t('statusOptions.23'), color: "info" },
      24: { text: t('statusOptions.24'), color: "primary" },
      25: { text: t('statusOptions.25'), color: "success" },
      26: { text: t('statusOptions.26'), color: "danger" },
      27: { text: t('statusOptions.27'), color: "warning" },
      28: { text: t('statusOptions.28'), color: "danger" },
      29: { text: t('statusOptions.29'), color: "danger" },
      30: { text: t('statusOptions.30'), color: "warning" },
    };

    const statusInfo = statusMap[status] || {
      text: t('statusOptions.unknown', 'Unknown'),
      color: "secondary",
    };
    return (
      <span className={`badge bg-${statusInfo.color} m-2`}>
        {statusInfo.text}
      </span>
    );
  };

  const handleStatusUpdate = async (status: number, comment?: string) => {
    const trimmedComment = (comment || "").trim();
    if (formData.orderStatus === 0 && status === 2 && !trimmedComment) {
      showErrorToast("Note is required when rejecting a pending order");
      return;
    }

    setUpdating(true);
    console.log(status);
    try {
      const response = await fetch(
        `${import.meta.env.VITE_APP_API_BASE_URL}/adminorder/updatestatus`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId: formData.id, // Assuming formData contains order ID
            orderStatus: status, // Passed as an argument
            comment: trimmedComment,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update order status");
      }
      setUpdating(false);

      const data = await response.json();
      console.log("Status Update Response:", data);
      showSuccessToast("Order updated successfully!");
      // navigate("/order/edit/" + formData.id);
      // Refresh the page by refetching order details
      setFormData((prevData) => ({
        ...prevData,
        orderStatus: status,
      }));
    } catch (error) {
      console.error("Error updating order status:", error);
      showErrorToast("Error: " + error.message);
    }
  };

  if (loading) {
    return <div className="text-center mt-4">{t('messages.loading')}</div>;
  }

  const breadcrumbs = [
    { path: '/order/index', label: t('orders:breadcrumbs.orders') },
    { label: `${t('editOrder')} #${formData.id}` }
  ];

  return (
    <PageLayout
      title={`${t('editOrder')} #${formData.id}`}
      breadcrumbs={breadcrumbs}

    >
      {/* Tabbed Interface */}
      <div className={`card shadow-lg border-0 rounded-3 ${isRTL ? 'rtl' : ''}`} dir={direction}>
        <div className="card-header bg-light">
          <ul className={`nav nav-tabs card-header-tabs ${isRTL ? 'rtl-tabs' : ''}`} id="orderTabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="form-tab"
                data-bs-toggle="tab"
                data-bs-target="#form-tab-pane"
                type="button"
                role="tab"
                aria-controls="form-tab-pane"
                aria-selected="true"
              >
                <HiDocumentText className={`${isRTL ? 'ms-2' : 'me-2'}`} />
                {t('tabs.coreFormFields')}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="status-tab"
                data-bs-toggle="tab"
                data-bs-target="#status-tab-pane"
                type="button"
                role="tab"
                aria-controls="status-tab-pane"
                aria-selected="false"
              >
                <HiClipboardList className={`${isRTL ? 'ms-2' : 'me-2'}`} />
                {t('tabs.statusManagement')}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="invoices-tab"
                data-bs-toggle="tab"
                data-bs-target="#invoices-tab-pane"
                type="button"
                role="tab"
                aria-controls="invoices-tab-pane"
                aria-selected="false"
              >
                <HiDocumentDuplicate className={`${isRTL ? 'ms-2' : 'me-2'}`} />
                {t('tabs.invoiceManagement')}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="history-tab"
                data-bs-toggle="tab"
                data-bs-target="#history-tab-pane"
                type="button"
                role="tab"
                aria-controls="history-tab-pane"
                aria-selected="false"
              >
                <HiClock className={`${isRTL ? 'ms-2' : 'me-2'}`} />
                {t('tabs.orderHistory')}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="summary-tab"
                data-bs-toggle="tab"
                data-bs-target="#summary-tab-pane"
                type="button"
                role="tab"
                aria-controls="summary-tab-pane"
                aria-selected="false"
              >
                <HiChartBar className={`${isRTL ? 'ms-2' : 'me-2'}`} />
                {t('tabs.orderSummary')}
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body p-0">
          <div className="tab-content" id="orderTabsContent">
            {/* Core Form Fields Tab */}
            <div
              className="tab-pane fade show active"
              id="form-tab-pane"
              role="tabpanel"
              aria-labelledby="form-tab"
              tabIndex={0}
            >
              <div className="p-4">
                <OrderForm
                  formData={formData}
                  countries={countries}
                  currencies={currencies}
                  paymentMethods={paymentMethods}
                  categories={categories}
                  shippingCompanys={shippingCompanys}
                  cities={cities}
                  weightMeasurementUnits={weightMeasurementUnits}
                  lengthMeasurementUnits={lengthMeasurementUnits}
                  isLBPriceEnabled={isLBPriceEnabled}
                  setIsLBPriceEnabled={setIsLBPriceEnabled}
                  handleInputChange={handleInputChange}
                  handleQuantityChange={handleQuantityChange}
                  updateOrder={updateOrder}
                  calculateOrder={calculateOrder}
                  resetOrder={resetOrder}
                  handleStatusUpdate={handleStatusUpdate}
                  updating={updating}
                  calculatingOrder={calculatingOrder}
                  resettingOrder={resettingOrder}
                  id={id}
                />
              </div>
            </div>

            {/* Status Management Tab */}
            <div
              className="tab-pane fade"
              id="status-tab-pane"
              role="tabpanel"
              aria-labelledby="status-tab"
              tabIndex={0}
            >
              <div className="p-4">
                <OrderStatus
                  formData={formData}
                  orderStatusForm={{ ...orderStatusForm, paymentGateways: paymentGateways }}
                  handleStatusFormInputChange={handleStatusFormInputChange}
                  confirmPendingStatus={confirmPendingStatus}
                  getExtraFieldLabel={getExtraFieldLabel}
                  getStatusBadge={getStatusBadge}
                  updatingStatus={updatingStatus}
                  messageStatus={messageStatus}
                  confirmMessage={confirmMessage}
                  updateOrderStatus={updateOrderStatus}
                  onReload={() => setReload(!reload)}
                />
              </div>
            </div>

            {/* Invoice Management Tab */}
            <div
              className="tab-pane fade"
              id="invoices-tab-pane"
              role="tabpanel"
              aria-labelledby="invoices-tab"
              tabIndex={0}
            >
              <div className="p-4">
                <OrderInvoices
                  formData={formData}
                  exchangeRate={exchangeRate}
                  id={id}
                />
              </div>
            </div>

            {/* Order History Tab */}
            <div
              className="tab-pane fade"
              id="history-tab-pane"
              role="tabpanel"
              aria-labelledby="history-tab"
              tabIndex={0}
            >
              <div className="p-4">
                <OrderHistory
                  formData={formData}
                  selectedLog={selectedLog}
                  setSelectedLog={setSelectedLog}
                />
              </div>
            </div>

            {/* Order Summary Tab */}
            <div
              className="tab-pane fade"
              id="summary-tab-pane"
              role="tabpanel"
              aria-labelledby="summary-tab"
              tabIndex={0}
            >
              <div className="p-4">
                <OrderSummary
                  formData={formData}
                  exchangeRate={exchangeRate}
                  netPriceUsd={netPriceUsd}
                  netPriceInIqd={netPriceInIqd}
                  fxLock={fxLock}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
